// projects/humanresources-personnel/src/assets/i18n/*/hr-per-personnel-organization.json
export class HrPerPersonnelOrganizationKey {
    private static readonly keyPrefix = 'hrPerPersonnelOrg';
    public static title = `${HrPerPersonnelOrganizationKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerPersonnelOrganizationKey.keyPrefix}.pageHeader`;
    public static workAreaUuid = `${HrPerPersonnelOrganizationKey.keyPrefix}.workAreaUuid`;
    public static workSubareaUuid = `${HrPerPersonnelOrganizationKey.keyPrefix}.workSubareaUuid`;
    public static employeeTypeUuid = `${HrPerPersonnelOrganizationKey.keyPrefix}.employeeTypeUuid`;
    public static employeeSubtypeUuid = `${HrPerPersonnelOrganizationKey.keyPrefix}.employeeSubtypeUuid`;
    public static payPayrollSwitchUuid = `${HrPerPersonnelOrganizationKey.keyPrefix}.payPayrollSwitchUuid`;
    public static posObjectDefId = `${HrPerPersonnelOrganizationKey.keyPrefix}.posObjectDefId`;
    public static titleObjectDefId = `${HrPerPersonnelOrganizationKey.keyPrefix}.titleObjectDefId`;
    public static cadreObjectDefId = `${HrPerPersonnelOrganizationKey.keyPrefix}.cadreObjectDefId`;
    public static orgObjectDefId = `${HrPerPersonnelOrganizationKey.keyPrefix}.orgObjectDefId`;
    public static movementId = `${HrPerPersonnelOrganizationKey.keyPrefix}.movementId`;
    public static payrollSwitch = `${HrPerPersonnelOrganizationKey.keyPrefix}.payrollSwitch`;
    public static serviceClass = `${HrPerPersonnelOrganizationKey.keyPrefix}.serviceClass`;
}
